export default "__VITE_ASSET__BVnhHB0b__"